import { createContext } from 'react';

import { useCdmSelectedLocationContext } from '../selected-location-provider/cdm-selected-location-context';

export interface CdmAppConfigFiltersProviderContextInterface {
  useCdmSelectedLocationContext: typeof useCdmSelectedLocationContext;
}

export const defaultValue: CdmAppConfigFiltersProviderContextInterface = {
  useCdmSelectedLocationContext,
};

export const CdmAppConfigFiltersProviderContext =
  createContext<CdmAppConfigFiltersProviderContextInterface>(defaultValue);
